import React from 'react'
import {Trans, translate} from 'react-i18next'

import View from 'components/View'
import Title from 'components/Title'
import Note from 'components/Note'
import Link from 'components/Link'
import PageMessage from 'components/PageMessage'
import EmailVerifiedSubtitle from './EmailVerifiedSubtitle'
import {getLang} from 'utils/stringUtils'
import LinkWithButton from '../LinkWithButton'
import {getAboutLink} from 'utils/languageUtils'

const EmailVerifiedMessage = ({t, handleClick, loading}) => {
  const profileUrl = `https://profile.${process.env.REACT_APP_OVERRIDE_DOMAIN}?lang=${getLang(window.location.search)}`

  return (
    <View>
      <Title>{t('email-verified.title')}</Title>
      <EmailVerifiedSubtitle>{t('email-verified.subtitle')}</EmailVerifiedSubtitle>
      <PageMessage>
        <Note light>{t('email-verified.message')}</Note>
      </PageMessage>
      <LinkWithButton
        to={profileUrl}
        text={t('email-verified.redirect-button')}
        onClick={handleClick && handleClick(profileUrl)}
        loading={loading}
      />
      <Note marginTop="20px" light>
        <Trans i18nKey="email-verified.link">
          text
          <Link to={getAboutLink()} target="_blank" rel="noopener noreferrer" fontSize="inherit" secondary external>
            text
          </Link>
        </Trans>
      </Note>
    </View>
  )
}

export default translate()(EmailVerifiedMessage)
